module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-a576c25169a3ca829e8ad98e267235f3.png";